<script>
import { mapState, mapMutations } from "vuex";
import HandlingShipping from "@/components/ContractModals/Components/BaseParts/HandlingShipping";

export default {
  extends: HandlingShipping,
  computed: {
    ...mapState("PurchaseOrderSt2ContractModal", ["handlingShipping"])
  },
  methods: {
    ...mapMutations("PurchaseOrderSt2ContractModal", [
      "setHandlingShippingLabourQuantity",
      "setHandlingShippingUnitsOne",
      "setHandlingShippingHourlyPrice",
      "setHandlingShippingUnitsTwo",
      "setHandlingShippingIncoterms"
    ])
  }
};
</script>
